<div class="contact-page">

    <!-- =====================================================
         CONTACT HERO
    ====================================================== -->

    <section class="contact-hero">

        <div class="contact-grid">

            <!-- =================================================
                 LEFT CONTENT
            ================================================== -->

            <div class="contact-intro">

                <h1>
                    Contact Us
                    <span>Today</span>
                </h1>

                <p class="contact-description">
                    Whether you're talking through a repair quote or
                    sitting at the closing table, we're available by
                    phone and text, and quotes run 7 days a week.
                </p>

            </div>


            <!-- =================================================
                 REACH US
            ================================================== -->

            <div class="contact-reach">

                <!-- PHONE -->

                <a href="tel:7046261776" class="reach-card phone-card">

                    <span class="reach-icon phone-icon">
                        ☎
                    </span>

                    <span class="reach-content">

                        <span class="reach-label">
                            CALL
                        </span>

                        <span class="reach-value">
                            704.626.1776
                        </span>

                    </span>

                </a>


                <!-- EMAIL -->

                <a href="mailto:info@spekwo.com" class="reach-card email-card">

                    <span class="reach-icon email-icon">
                        @
                    </span>

                    <span class="reach-content">

                        <span class="reach-label">
                            EMAIL
                        </span>

                        <span class="reach-value">
                            info@spekwo.com
                        </span>

                    </span>

                </a>

            </div>


            <!-- =================================================
                 OFFICE
            ================================================== -->

            <div class="contact-office">

                <div class="office-eyebrow">

                    <span>
                        OFFICE
                    </span>

                    <span class="office-line"></span>

                </div>


                <div class="office-box">

                    <span class="office-icon">
                        ⌂
                    </span>

                    <span class="office-content">

                        <span class="office-label">
                            OFFICE
                        </span>

                        <a href="https://www.google.com/maps/search/?api=1&query=19701+Bethel+Church+Road+Suite+103-119+Cornelius+NC+28031"
                            target="_blank" rel="noopener">
                            19701 Bethel Church Road,
                            Suite 103-119<br>
                            Cornelius, NC 28031
                        </a>

                    </span>

                </div>

            </div>


            <!-- =================================================
                 SERVICE AREAS
            ================================================== -->

            <div class="contact-secondary">

                <div class="service-area-heading">

                    <span>
                        SERVICE AREAS
                    </span>

                    <span class="service-line"></span>

                </div>


                <div class="service-area-chips">

                    <a routerLink="/service-area-asheville">
                        Asheville
                    </a>

                    <a routerLink="/service-area-charlotte">
                        Greater Charlotte
                    </a>

                    <a routerLink="/service-area-raleigh">
                        Raleigh
                    </a>

                    <a routerLink="/service-area-triad">
                        The Triad
                    </a>

                    <a routerLink="/service-area-upstate-sc">
                        Upstate SC
                    </a>

                    <span>
                        + Surrounding areas
                    </span>

                </div>

            </div>


            <!-- =================================================
                 FORM CARD
            ================================================== -->

            <div class="contact-form-wrapper">

                <div class="form-decoration"></div>

                <div class="contact-form-card">

                    <!-- FORM HEADER -->

                    <div class="form-header">

                        <span>
                            SEND A MESSAGE
                        </span>

                        <span class="form-badge">
                            7 DAYS / WK
                        </span>

                    </div>


                    <!-- =================================================
                         SUCCESS MESSAGE
                    ================================================== -->

                    <div class="form-success" *ngIf="submitted">

                        <div class="success-icon">
                            ✓
                        </div>

                        <h2>
                            Message sent.
                        </h2>

                        <p>
                            We'll get back to you shortly.
                            Need us now?
                            <br>

                            <a href="tel:7046261776">
                                Call 704.626.1776
                            </a>
                        </p>

                    </div>


                    <!-- =================================================
                         FORM
                    ================================================== -->

                    <form *ngIf="!submitted" [formGroup]="contactForm" (ngSubmit)="submitForm()" novalidate>

                        <div class="form-grid">


                            <!-- NAME -->

                            <div class="form-field full-width">

                                <label>
                                    NAME *
                                </label>

                                <input type="text" formControlName="name" autocomplete="name">

                                <small *ngIf="
                                        contactForm.get('name')?.touched &&
                                        contactForm.get('name')?.invalid
                                    ">
                                    Please enter your name.
                                </small>

                            </div>


                            <!-- EMAIL -->

                            <div class="form-field">

                                <label>
                                    EMAIL *
                                </label>

                                <input type="email" formControlName="email" autocomplete="email" inputmode="email">

                                <small *ngIf="
                                        contactForm.get('email')?.touched &&
                                        contactForm.get('email')?.invalid
                                    ">
                                    Please enter a valid email address.
                                </small>

                            </div>


                            <!-- PHONE -->

                            <div class="form-field">

                                <label>
                                    PHONE
                                </label>

                                <input type="tel" formControlName="phone" autocomplete="tel" inputmode="tel">

                            </div>


                            <!-- ROLE -->
                            <!--
                                IMPORTANT: this select must be EXCLUDED from any
                                global nice-select (or similar jQuery dropdown
                                plugin) initialization elsewhere in the codebase.
                                It carries the "native-role-select" class for
                                that purpose. Do not let it be wrapped/hidden by
                                nice-select, or Angular's formControlName binding
                                will silently stop working for this field.
                            -->

                            <div class="form-field">

                                <label>
                                    I AM A…
                                </label>

                                <select
                                    formControlName="role"
                                    class="native-role-select"
                                >

                                    <option value="">
                                        Select one…
                                    </option>

                                    <option value="Real Estate Agent">
                                        Real Estate Agent
                                    </option>

                                    <option value="Buyer">
                                        Buyer
                                    </option>

                                    <option value="Seller">
                                        Seller
                                    </option>

                                    <option value="Investor">
                                        Investor
                                    </option>

                                    <option value="Home Inspector">
                                        Home Inspector
                                    </option>

                                    <option value="Property Manager">
                                        Property Manager
                                    </option>

                                    <option value="Other">
                                        Other
                                    </option>

                                </select>

                            </div>


                            <!-- CITY -->

                            <div class="form-field">

                                <label>
                                    CITY / TOWN
                                </label>

                                <input type="text" formControlName="city" autocomplete="address-level2">

                            </div>


                            <!-- MESSAGE -->

                            <div class="form-field full-width">

                                <label>
                                    HOW CAN WE HELP? *
                                </label>

                                <textarea formControlName="message" rows="4"
                                    placeholder="Tell us about your inspection report, repair, or question"></textarea>

                                <small *ngIf="
                                        contactForm.get('message')?.touched &&
                                        contactForm.get('message')?.invalid
                                    ">
                                    Please tell us how we can help.
                                </small>

                            </div>

                        </div>


                        <!-- SMS CONSENT -->

                        <label class="sms-consent">

                            <input type="checkbox" formControlName="smsOptIn">

                            <span>
                                I agree to receive SMS text messages
                                from speKwo, LLC related to my request.
                                Message &amp; data rates may apply.
                                Reply STOP to opt out, HELP for help.
                                See
                                <a routerLink="/terms-conditions">
                                    Terms
                                </a>
                                &amp;
                                <a routerLink="/privacy-policy">
                                    Privacy
                                </a>.
                            </span>

                        </label>


                        <!-- ERROR -->

                        <div class="form-error" *ngIf="errorMessage">
                            {{ errorMessage }}
                        </div>


                        <!-- SUBMIT -->

                        <button type="submit" class="send-button" [disabled]="isSubmitting">

                            <span *ngIf="!isSubmitting">
                                Send Message →
                            </span>

                            <span *ngIf="isSubmitting">
                                Sending...
                            </span>

                        </button>

                    </form>

                </div>

            </div>

        </div>

    </section>

</div>